import React from 'react';
import Typist from 'react-typist';

const line1 = `<script src=`;
const line1_2 = `"https://cdn.auth0.com/js/lock-10.0.min.js"`;
const line1_3 = `</script>`;
const line2 = `<script type=`;
const line2_2 = `"text/Javascript"`;
const line2_3 = `>`;
const line3 = `   var`;
const line3_2 = `lock =`;
const line3_3 = `new`;
const line3_4 = `Auth0Lock('4N28qGxpvbvu4xBdSbY2U7C70AJS4B29', 'matias);'`;
const line4 = `   function signIn`;
const line4_2 = `(){`;
const line5 = `       lock.show({`;
const line5_2 = `           callbackURL: ‘http://localhost:CHANGE-TO-YOUR-PORT,`;
const line5_3 = `           responseType: ‘code’,`;
const line5_n = `           icon:'http://my-icon-url/icon.png',`;
const line5_4 = `           authParams: {`;
const line5_5 = `               scope: ‘openid profile’`;
const line5_6 = `           }`;
const line5_7 = `       });`;
const line6 = `    }`;
const line7 = `</script>`;
const line8 = `<button onClick=`;
const line8_2 = `"signIn()"`;
const line8_3 = `>`;
const line8_4 = `Login`;
const line8_5 = `</button>`;

const CodeEditor = ({ visibility, typing1, onDone1 }) => {
  return (
    <div className={`step-hidden-visibility ${visibility ? 'step-visibility' : ''}`}>
      <div className="window-wrapper editor">
        <svg
          width="555"
          height="547"
          className="code-editor-bg"
          viewBox="0 0 555 547"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          preserveAspectRatio="xMinYMin meet"
        >
          <defs>
            <rect id="path-1" width="555" height="547" />
          </defs>
          <g id="Page-1" fill="none" fillRule="evenodd">
            <g id="Group-8" transform="translate(0 -27)">
              <g id="body" transform="translate(0 27)">
                <mask id="mask-2" fill="#fff">
                  <use xlinkHref="#path-1" />
                </mask>
                <use id="Rectangle" fill="#3A424A" xlinkHref="#path-1" />
                <rect id="Rectangle" fill="#2F383D" width="555" height="547" />
                <path
                  d="M0,3.00926706 C0,1.34729476 1.34831184,0 2.99619829,0 L58,0 L58,547 L2.99619829,547 C1.34144367,547 0,545.664233 0,543.990733 L0,3.00926706 Z"
                  id="Rectangle-696"
                  fill="#1D2326"
                  opacity=".468"
                />
                <g id="Group-6" fontFamily=".AppleSystemUIFont" fontSize="14.4" opacity=".2">
                  <text transform="translate(20 30)" id="01-02-03-04-05-06-07">
                    <tspan x="0" y="14" fill="#FFF">01</tspan>
                    <tspan x="0" y="44.4" fill="#FFF">02</tspan>
                    <tspan x="0" y="74.8" fill="#FFF">03</tspan>
                    <tspan x="0" y="105.2" fill="#FFF">04</tspan>
                    <tspan x="0" y="135.6" fill="#FFF">05</tspan>
                    <tspan x="0" y="166" fill="#FFF">06</tspan>
                    <tspan x="0" y="196.4" fill="#FFF">07</tspan>
                    <tspan x="0" y="226.8" fill="#FFF">08</tspan>
                    <tspan x="0" y="257.2" fill="#FFF">09</tspan>
                    <tspan x="0" y="287.6" fill="#FFF">10</tspan>
                    <tspan x="0" y="318" fill="#FFF">11</tspan>
                    <tspan x="0" y="348.4" fill="#FFF">12</tspan>
                    <tspan x="0" y="378.8" fill="#FFF">13</tspan>
                    <tspan x="0" y="409.2" fill="#FFF">14</tspan>
                    <tspan x="0" y="439.6" fill="#FFF">15</tspan>
                    <tspan x="0" y="470" fill="#FFF">16</tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <div className="code-wrapper editor">
          <pre>
            <p className="script-tag">{line1}<span>{line1_2}</span>{line1_3}</p>
            <p className="script-tag">{line2}<span>{line2_2}</span>{line2_3}</p>
            <p className="var-line">
              {line3}<span> {line3_2}</span> {line3_3}<span> {line3_4}</span>
            </p>
            <p className> </p>
            <p className="function-line">{line4}<span>{line4_2}</span></p>
            <p className="simple-line">{line5}</p>
            <p className="simple-line">{line5_2}</p>
            <p className="simple-line">{line5_3}</p>
            {typing1 &&
              <Typist
                avgTypingSpeed={40}
                startDelay={2000}
                cursor={{ show: false }}
                onTypingDone={onDone1}
              >
                {line5_n}
              </Typist>}
            <p className="simple-line">{line5_4}</p>
            <p className="simple-line">{line5_5}</p>
            <p className="simple-line">{line5_6}</p>
            <p className="simple-line">{line5_7}</p>
            <p className="simple-line">{line6}</p>
            <p className="script-tag">{line7}</p>
            <p className="html-script-tag">
              {line8}<span>{line8_2}</span>{line8_3}<span>{line8_4}</span>{line8_5}
            </p>
          </pre>
          <div className="select-copy-overlay" />
        </div>
      </div>
    </div>
  );
};

export default CodeEditor;



// WEBPACK FOOTER //
// ./src/components/OnboardingFlow/components/CodeEditor.js